import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47298a7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reportFill" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  slot: "default",
  class: "el-icon-plus"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 支持 jpeg, jpg, png 格式，不超过20m ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  slot: "default",
  class: "el-icon-plus"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 支持 jpeg, jpg, png 格式，不超过20m ", -1))

import { basicFormConfig } from './config/form.config'
import { useUpload } from '@/hooks/useUpload'
import { reactive, ref } from 'vue'
import localCache from '@/utils/cache'
import { getListData } from '@/service/main/system'
import { ElMessage } from 'element-plus'
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Fill',
  setup(__props) {

const [
  uploadRef,
  extraData,
  files,
  action,
  beforeUpload,
  proveUpload,
  onSuccess,
  onExceed,
  filesMap,
  proveFiles,
  records
] = useUpload()
const fileList = ref<any[]>([])
const route = useRoute()
const defaultInfo = ref({})
defaultInfo.value.isCreate = true
defaultInfo.value.resourceType = route.query.resourceType
const otherInfo = reactive({
  upload: '',
  upload0: ''
})
const canUseCorp = [
  '南京秦淮天鼎证券投资',
  '天鼎证券投资秦淮',
  '天鼎证券投顾',
  '天鼎证券投资咨询',
  '江苏天鼎',
  '江苏天鼎秦淮'
]
const getCorpIds = async () => {
  let corpData = await getListData('/main/enterpriseWechat/config/listAll', {})
  const teacher = basicFormConfig.iForms[1].formItems.find(
    (item) => item.field === 'corpId'
  )
  teacher!.options = corpData
    .filter((o: any) => canUseCorp.indexOf(o.name) != -1)
    .map((item: any) => {
      return { title: item.name, value: item.corPid }
    })
}
getCorpIds()

const handleValid = (data: any) => {
  otherInfo.upload = ''
  otherInfo.upload0 = ''
  filesMap.value.forEach((value: string, key: string) => {
    otherInfo.upload = otherInfo.upload + value + ','
  })
  otherInfo.upload = otherInfo.upload.slice(0, -1)
  console.log(otherInfo.upload)

  proveFiles.value.forEach((value: string, key: string) => {
    otherInfo.upload0 = otherInfo.upload0 + value + ','
  })
  otherInfo.upload0 = otherInfo.upload0.slice(0, -1)

  if (data.corpWechatNo) {
    // 正则表达式用于验证中国大陆手机号
    const phoneRegex = /^1[3-9]\d{9}$/
    if (!phoneRegex.test(data.corpWechatNo)) {
      ElMessage.error('请输入正确的企业微信手机号')
      return false
    }
  }
  return true
}
const handleImgRemove = (uploadFile: any, uploadFiles: any) => {
  filesMap.value.delete(String(uploadFile.uid))
}

const handleProveImageRemove = (uploadFile: any, uploadFiles: any) => {
  proveFiles.value.delete(String(uploadFile.uid))
}

let dialogImageUrl = ref()
const dialogVisible = ref(false)
const handlePreview = (file: any) => {
  dialogImageUrl.value = file.url
  dialogVisible.value = true
}

const closePage = () => {
  window.close()
}

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_BasicForm = _resolveComponent("BasicForm")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BasicForm, {
        basicFormConfig: _unref(basicFormConfig),
        checkInfo: '请于资源打满日起3到5日内完成非精准与同行备注',
        "col-layout": {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
        pageName: "customResourceApply",
        defaultInfo: defaultInfo.value,
        otherInfo: otherInfo,
        valid: true,
        validOtherInfo: handleValid,
        onClosePage: closePage
      }, {
        insert: _withCtx(() => [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            "auto-upload": true,
            action: _unref(action),
            data: _unref(extraData),
            "file-list": fileList.value,
            "before-upload": _unref(beforeUpload),
            "on-success": _unref(onSuccess),
            "on-exceed": _unref(onExceed),
            accept: ".jpeg,.jpg,.png",
            "on-remove": handleImgRemove,
            multiple: "",
            "list-type": "picture-card",
            "on-preview": handlePreview
          }, {
            tip: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["action", "data", "file-list", "before-upload", "on-success", "on-exceed"])
        ]),
        proveInsert: _withCtx(() => [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            "auto-upload": true,
            action: _unref(action),
            data: _unref(extraData),
            "file-list": fileList.value,
            "before-upload": _unref(proveUpload),
            "on-success": _unref(onSuccess),
            "on-exceed": _unref(onExceed),
            accept: ".jpeg,.jpg,.png",
            "on-remove": handleProveImageRemove,
            multiple: "",
            "list-type": "picture-card",
            "on-preview": handlePreview
          }, {
            tip: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["action", "data", "file-list", "before-upload", "on-success", "on-exceed"])
        ]),
        _: 1
      }, 8, ["basicFormConfig", "defaultInfo", "otherInfo"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "图片预览",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      width: "50%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_image, {
          src: _unref(dialogImageUrl),
          fit: "fit",
          lazy: ""
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})